import { useEffect, useState } from "react";
import { ProjectJobDescription } from "../../Models";
import { Spinner } from "../Shared/Spinner";
import NoData from "../Shared/NoData";
import JobDescriptionCard from "./JobDescriptionCard";
import JobDescriptionModal, { JobDescriptionPayload } from "./JobDescriptionModal";
import { useNotification } from "../../context/NotificationContext";
import {
  CreateJobDescription,
  GetJobDescriptions,
} from "../../api/jobdescription.api";
import useApiToken from "../../hooks/useApiToken";

export default function JobDescriptions() {
  const [loading, setLoading] = useState(true);
  const [jobDescriptions, setJobDescriptions] = useState<ProjectJobDescription[]>([]);
  const [isCreateModalOpen, setIsCreateModalOpen] = useState<boolean>(false);
  const { success } = useNotification();
  const token = useApiToken();

  useEffect(() => {
    if (!token) return;
    fetchJobDescriptions();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  const fetchJobDescriptions = async () => {
    if (!token) return;
    setLoading(true);
    await GetJobDescriptions(token).then((res) => {
      setJobDescriptions(res);
      setLoading(false);
    });
  };

  const handleCreate = async (payload: JobDescriptionPayload) => {
    if (!token) return;
    await CreateJobDescription(payload, token);
    success("Success", "Job description has been created!");
    fetchJobDescriptions();
  };

  return (
    <>
      <header className="bg-gray-100 py-8 dark:bg-darkbglight">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 flex items-center justify-between flex-wrap">
          <h1 className="mt-2 text-2xl font-bold leading-7 text-gray-800 sm:text-3xl sm:tracking-tight dark:text-gray-300">
            Job Descriptions
          </h1>
          <button
            type="button"
            className="inline-flex items-center rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-entntorange focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
            onClick={() => setIsCreateModalOpen(true)}
          >
            Create new job description
          </button>
        </div>
      </header>
      {loading ? (
        <div className="h-[50vh] flex items-center justify-center">
          <Spinner height="h-14" width="h-14" />
        </div>
      ) : jobDescriptions.length === 0 ? (
        <NoData
          title="No Job Descriptions"
          description="There are currently no project-specific job descriptions. Click 'Create new job description' to start adding."
        />
      ) : (
        jobDescriptions.map((jobDescription) => (
          <JobDescriptionCard
            jobDescription={jobDescription}
            fetchJobDescriptions={fetchJobDescriptions}
            key={jobDescription.id}
          />
        ))
      )}
      {isCreateModalOpen && (
        <JobDescriptionModal
          onSave={handleCreate}
          onClose={() => setIsCreateModalOpen(false)}
        />
      )}
    </>
  );
}
